@if (isLoggedIn()) {
  <lib-announcement-banner-container [appType]="announcementAppType"></lib-announcement-banner-container>
}

<router-outlet></router-outlet>

<router-outlet name="popup"></router-outlet>

@if (isLoggedIn() && helpApiUrl && showHelpChat) {
  <lib-help-launcher [showSources]="showHelpSources"></lib-help-launcher>
}

<lib-toasts aria-live="polite" aria-atomic="true"></lib-toasts>
